import { createSelector } from "@reduxjs/toolkit";
import uniqBy from "lodash/uniqBy";

import { Variant } from "custom-types/MenuItemV2";
import { Offer } from "custom-types/Offer";
import { RootState } from "redux/reducers/rootReducer";

import { getIsDualMenu } from "./dispensary";
import { getUserPrefersMedical } from "./user";

const getMenuItemState = (state: RootState) => state.menuItem;

export const getCurrentMenuItem = createSelector(
  [getMenuItemState],
  (state) => state.currentMenuItem
);

export const getSimilarMenuItems = createSelector(
  [getMenuItemState],
  (state) => state.similarMenuItems
);

export const getIsSimilarItemsLoaded = createSelector(
  [getMenuItemState],
  (state) => state.similarItemsLoaded
);

export const getVariantsToShow = createSelector(
  [getUserPrefersMedical, getIsDualMenu, getCurrentMenuItem],
  (userPrefersMedical, dispensaryIsDualMenu, currentMenuItem) =>
    (dispensaryIsDualMenu
      ? currentMenuItem?.variants?.filter(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
          (variant: any) => variant.medical === userPrefersMedical
        )
      : currentMenuItem?.variants) || []
);

export const getOffers = createSelector(
  [getCurrentMenuItem],
  (menuItem) => menuItem?.offers
);

export const getVariantOffersToShow = createSelector(
  // * Chaining from this selector helps us show valid offers,
  // * even when filtered by menu type (med/rec).
  [getVariantsToShow],
  (variants) => {
    const offers = variants.reduce((offersArray: Offer[], variant: Variant) => {
      return [...offersArray, ...variant.offers];
    }, []);
    // * Need to unique by offer id, in case the same BOGO is applied
    // * to multiple variants. In most cases where this selector is used,
    // * we only want to show an Offer once.
    const uniqueOffers = uniqBy(offers, (offer: Offer) => offer.id);
    return uniqueOffers;
  }
);
